export default "__VITE_ASSET__e4d732b7__"